import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: '澳门彩的基本玩法是什么？',
    answer: '澳门彩主要包括澳门彩票（Macau Lottery）、即发彩票及体育彩票三大类。其中澳门彩票是最经典的数字型彩票，玩家从1至49中选择6个号码进行投注，开奖时随机摇出6个正选号码及1个特别号码，根据匹配数量确定中奖等级。每周三和周六晚间开奖。',
  },
  {
    question: '如何购买澳门彩票？',
    answer: '您可前往澳门各区的授权投注站购买澳门彩票。在投注站领取投注单，用黑色或蓝色笔填写选择的号码后交予店员，付款后即可领取正式彩票。请确保您已年满18周岁，并在合法授权投注站购买。',
  },
  {
    question: '澳门彩的开奖时间是什么时候？',
    answer: '澳门彩票（Macau Lottery）每周开奖两次：每周三晚上20:30（澳门时间）和每周六晚上20:30（澳门时间）。每期投注截止时间为开奖当日晚间19:45。法定节假日若无特别通知，照常开奖。',
  },
  {
    question: '中奖后如何兑奖？',
    answer: '中奖后请在60天有效期内携带中奖彩票原件和有效身份证件办理兑奖。小额奖金可在投注站直接兑奖，大额奖金需前往澳门彩票股份有限公司总部办理。澳门地区中奖奖金免征税费。',
  },
  {
    question: '澳门彩有哪些中奖技巧？',
    answer: '虽然澳门彩本质上是一种随机游戏，但您可以通过合理策略优化体验：设定预算并坚持执行、参考历史数据了解号码分布特征、合理运用复式和胆拖投注方式。最重要的是保持理性心态，将购彩视为娱乐而非投资。',
  },
  {
    question: '外地游客可以购买澳门彩吗？',
    answer: '可以。澳门彩票面向所有年满18周岁的人士开放，不论本地居民还是外地游客均可合法购买。中奖后，游客同样可按正常流程办理兑奖手续。',
  },
  {
    question: '如何查询最新的开奖结果？',
    answer: '您可通过以下官方渠道查询：澳门彩票股份有限公司官方网站实时公布、授权投注站公告板及电子屏、澳门当地主要报章次日公告。建议通过至少两个渠道交叉核对开奖结果，确保准确性。',
  },
  {
    question: '什么是责任购彩？',
    answer: '责任购彩是指彩民在充分了解彩票随机性本质的基础上，以理性、适度的方式参与购彩。核心原则包括：设定购彩预算、将购彩视为娱乐而非投资、不追损失、控制购彩时间、保持清醒头脑。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section className="py-14 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              关于澳门彩的常见疑问解答
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-sm font-semibold text-foreground-900 pr-4 font-heading">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    openIndex === index
                      ? 'bg-accent-500 text-background-50 rotate-180'
                      : 'bg-secondary-100 text-secondary-600'
                  }`}>
                    <i className="ri-arrow-down-s-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}